export default __webpack_public_path__ + "static/Upward_logo-0d2d4671ac399d37e5e61064b1ca8887.png";